module.exports = __webpack_public_path__ + "img/who_international_map.402f0b61.svg";